module.exports = __webpack_public_path__ + "static/images/spike-ymw.bfd1d36.png";